













































import { Vue, Component, Prop } from "vue-property-decorator";
import SocialLinks from "@/components/SocialLinks.vue";
import moment from 'moment'
import { ROUTES_MAP } from '@/router'
import { resetCartInSession, resetSession } from "@/store/modules/global/mutations";
import GTMService from "@/services/GTMService";
import { isWishope } from "../common/utils";
import { mapActions } from "vuex";


const OrderConfirmationProps = Vue.extend({
  methods: {
    isWishope,
    ...mapActions("global", ["toggleHeader"]),

  },
})

@Component({
  components: {
    SocialLinks,
  },
})
export default class OrderConfirmation extends OrderConfirmationProps {
  @Prop() readonly checkout!: Checkout;
  @Prop() readonly cart!: MerchantCart;
  @Prop() readonly shopDetails!: MerchantShopDetails;
  @Prop() readonly selectedPayment: any;

  get validDate() {
    return moment().format('DD/MM/YYYY - HH:mm')
  }


  gotoStart() {

    resetCartInSession();
    resetSession();

    const { merchantId, shopId, vasId } = this.$route.params;

    setTimeout(() => {
      window.location.replace(`/${merchantId}/public/${shopId}/${vasId}`);
      // this.$router.replace({ name: ROUTES_MAP.VAS_ADDRESS, params: this.$route.params })
    }, 250)
  }

  goToLanding() {

    resetCartInSession();
    resetSession();

    const { merchantId, shopId, vasId } = this.$route.params;

    console.log('goToLanding', { merchantId, shopId, vasId });

    var url = "https://wishope.tinaba.it";
    if(shopId === '1002476') { url = 'https://crocerossamilano.wishope.valid.tinaba.it/'; }
    if(shopId === '1009902') { url = 'https://crocerossamilano.valid.tinaba.it/'; }

    setTimeout(() => {
      window.location.replace(url);
      // this.$router.replace({ name: ROUTES_MAP.VAS_ADDRESS, params: this.$route.params })
    }, 250)
  }

  mounted() {
    window.scrollTo(0, 0);

    GTMService.dataLayerPurchase(this.cart, this.shopDetails, this.checkout);

    this.toggleHeader(false);

  }
}
